const ValidationError = require('./errors/ValidationError');
const SchemaValidation = require('./SchemaValidation');

module.exports = class Default {
  constructor(bank, data, bankCode) {
    this._bank = bank;
    this._data = this._clearBankAccountData(data);
    this._schemaValidation = new SchemaValidation(this._data, bankCode);
    this._schema = this._schemaValidation.getSchema();
    this._agencySchemaLength = this._schema.agency.exactLength || this._schema.agency.maxLength;
    this._accountSchemaLength = this._schema.account.exactLength || this._schema.account.maxLength;
  }

  _clearBankAccountData(data) {
    data.bank_code = this._removeSpaces(data.bank_code);
    data.bank_ispb = this._removeSpaces(data.bank_ispb);
    data.agency = this._removeSpaces(data.agency);
    data.agency_digit = this._removeSpaces(data.agency_digit);
    data.account = this._removeSpaces(data.account);
    data.account_digit = this._removeSpaces(data.account_digit);
    return data;
  }

  _removeSpaces(value) {
    if (value) {
      return String(value).replace(/\s/g, '');
    }

    return value;
  }

  _removeUnnecessaryLeadingZeros(value, size) {
    if (value) {
      return this._fillZero(String(value).replace(/^0+/, ''), size);
    }
    return;
  }

  _fillZero(value, size) {
    while (value.length < size) {
      value = '0' + value;
    }

    return value;
  }

  _validateBank() {
    this._schemaValidation.validateBank();
  }

  _validateAgency() {
    this._schemaValidation.validateAgency();
  }

  _validateAccountType() {
    this._schemaValidation.validateAccountType();
  }

  _validateAccount() {
    this._schemaValidation.validateAccount();
    this._schemaValidation.validateAccountDigit();
  }

  _catchValidationErrors(e) {
    if (e instanceof ValidationError) {
      return e;
    } else {
      throw e;
    }
  }

  validate() {
    const errors = [];

    try {
      this._validateBank();
      this._validateAgency();
      this._validateAccountType();
      this._validateAccount(errors);
    } catch (e) {
      errors.push(this._catchValidationErrors(e));
    }

    return errors;
  }
};
